import { Action, ActionReducerMap, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store'
import * as RelationRelationOverview from './relation-relation-overview.reducer'

export const relationRelationFeatureKey = 'relationRelation'

export interface RelationRelationActivityState {
    relationRelationOverview: RelationRelationOverview.State
}

export interface State {
    relationRelation: RelationRelationActivityState
}

const map: ActionReducerMap<RelationRelationActivityState, Action> = {
    relationRelationOverview: RelationRelationOverview.reducer
}

export const reducers = (state: RelationRelationActivityState, action: Action) => combineReducers(map)(state, action);

const selectRelationRelationState = createFeatureSelector<RelationRelationActivityState>(relationRelationFeatureKey);

export const selectState = createSelector(selectRelationRelationState, state => state)
export const selectRelationRelationOverviewState = createSelector(selectState, state => state.relationRelationOverview)
export const selectRelationRelationOverview = createSelector(selectState, state => state.relationRelationOverview.relations)

export const selectRelationRelationOverviewList = createSelector(selectRelationRelationOverviewState, RelationRelationOverview.getList)
export const selectActivityOverviewPagination = createSelector(selectRelationRelationOverviewState, RelationRelationOverview.getPagination)

export const selectRelationRelationOverviewSorting = createSelector(selectRelationRelationOverviewState, RelationRelationOverview.getSorting)
export const selectChosenRelationId = createSelector(selectRelationRelationOverviewState, RelationRelationOverview.getRelationId)
export const selectRelationRelationOverviewFilter= createSelector(selectRelationRelationOverviewState, RelationRelationOverview.getFilter)

export const selectRelationRelationCreateError = createSelector(selectRelationRelationOverviewState, RelationRelationOverview.getCreateErrors)
export const selectRelationRelationCreateLoading = createSelector(selectRelationRelationOverviewState, RelationRelationOverview.getCreateLoading)

export const selectRelations = createSelector(selectRelationRelationOverviewState, RelationRelationOverview.getRelations)
